const PREFIX = '--'

export const setThemeCssColorVar = (name, color) => {
  document?.documentElement?.style?.setProperty?.(PREFIX + name, color)
}
